export const REQUIRED = "Required";

export const IS_EMAIL = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;



// WEBPACK FOOTER //
// ./src/constants/validations.js